import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Dropdown, Header, Icon, Loader, Table} from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import { artistPerformanceReportDateWise, artistPerformanceReportTitleWise, operatorPerformanceType, performanceReportDateWise } from '../../app/models/Restoration';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { toast } from 'react-toastify';
import agent from '../../app/api/agent';

const teamoptions = [
  { key: 1, text: 'QC', value: 'QC' },
  { key: 2, text: 'Artist', value: 'Artist' },
];

const reportoptions = [
  { key: 1, text: 'Title-Wise', value: 'Title-Wise' },
  { key: 2, text: 'Date-Wise', value: 'Date-Wise' },
];

const OperatorPerformanceColorization: React.FC = () => {
  const{RestorationStore, PivotStore}= useStore()
  const [selectedTeam, setSelectedTeam] = useState<string>('');
  const [selectedReport, setSelectedReport] = useState<string>('');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loadData, setLoadData] = useState<operatorPerformanceType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [checked, setChecked] = useState<boolean>(false)
  const [dateWiseData, setDateWiseData] = useState<performanceReportDateWise[]>([]);
  const [titleWiseData, setTitleWiseData] = useState<performanceReportDateWise[]>([]);
  const [artistdateWiseData, setArtistDateWiseData] = useState<artistPerformanceReportDateWise[]>([]);
  const [artistTitleWiseData, setArtistTitleWiseData] = useState<artistPerformanceReportTitleWise[]>([]);
  const [selectedTitle, setSelectedTitle] = useState<string>('');
  const currentDate = new Date();
  const [startDate, setStartDate] = useState(() => {
    return moment(currentDate).format('MM-DD-YYYY');
  });
  const [endDate, setendDate] = useState(() => {
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    return `${month}-${day}-${year}`;
  });

  const [assingTitleCode, setAssignTitleCode] = useState<
    { key: string; text: string; value: string }[]
  >([]);

  useEffect(() => {
    const fetchTitleCodes = async () => {
      await RestorationStore.getTitleCode();
      const loadTitleCode = RestorationStore.titleCodeData.map((titleCodeList: string) => ({
        key: titleCodeList,
        text: titleCodeList,
        value: titleCodeList,
      }));
      setAssignTitleCode(loadTitleCode);
    };

    fetchTitleCodes();
    // eslint-disable-next-line
  }, []);


  const handleChangeTeam = ( event: React.SyntheticEvent<HTMLElement>,data: any) => {
    setSelectedTeam(data.value as string);
  };

  const handleChangeReport =(event: React.SyntheticEvent<HTMLElement>,data: any)=>{
    setSelectedReport(data.value as string);
  }

  const handleChangeTitle = async (event: React.SyntheticEvent<HTMLElement>, data: any) => {
    const newTitle = data.value as string;
    setSelectedTitle(newTitle);
    if (newTitle) {
      try {
        await RestorationStore.performanceReportbyTitle(newTitle);
        setLoadData(RestorationStore.operatorPerformanceData);
        await handleViewReport();
      } catch (error) {
        toast.error('Error fetching performance report by title');
      }
    } else {
      setLoadData([]);
      setTitleWiseData([]);
      setArtistTitleWiseData([]);
    }
  };
    
  const setDate = (data: any, type: string) => {
    try {
      if (type === 'start') {
        setStartDate(moment(data).format('MM-DD-YYYY'));
      } else {
        if (type === 'end') setendDate(moment(data).format('MM-DD-YYYY'));
      }
    } catch (error) {
      toast.error('Error fetching Date');
    }
  };

  const titleBreak = ()=>{
    setChecked(!checked);
  }

  const handleViewReport = async () => {
    setLoading(true);
    if (selectedTeam === 'QC' && selectedReport === 'Date-Wise') {
      try {
        const response = await agent.ColorRestoration.performanceReportDateWise(startDate, endDate, checked)
        setDateWiseData(response.data); 
      } catch (error) {
        toast.error('Error fetching date-wise report');
      }
      finally {
        setLoading(false)
      }
    } else if (selectedTeam === 'QC' && selectedReport === 'Title-Wise'){
      try{
        const response = await agent.ColorRestoration.performanceReportTitleWise(selectedTitle);
        setTitleWiseData(response.data);
      } catch (error) {
        toast.error('Error fetching title-wise report');
      }
      finally {
        setLoading(false)
      }
    } else if (selectedTeam === 'Artist' && selectedReport === 'Date-Wise'){
      try{
        const response = await agent.ColorRestoration.artistPerformanceReportDateWise(startDate, endDate, checked)
        setArtistDateWiseData(response.data);
      } catch (error) {
        toast.error('Error fetching date-wise report')
      }
      finally {
        setLoading(false)
      }
    } else if (selectedTeam === 'Artist' && selectedReport === 'Title-Wise'){
      try{
        const response = await agent.ColorRestoration.artistPerformanceReportTitleWise(selectedTitle)
        setArtistTitleWiseData(response.data);
      } catch (error) {
        toast.error('Error fetching title-wise report');
      }
      finally {
        setLoading(false)
      }
    }
  };

  const handleDownloadReport = () => {
    let csvContent = "data:text/csv;charset=utf-8,";

    if (selectedTeam === 'QC') {
        if (selectedReport === 'Date-Wise' && checked) {
            csvContent += "Employee ID,Employee Name,Title Code,Actual Hours,Extra Hours,Fresh Frame,Correction Frame,Process Date\n";
            dateWiseData.forEach(data => {
                const row = `${data.employee_id},${data.employee_Name},${data.title_Code},${data.actual_Hours},${data.extra_Hours},${data.fresh_Frame},${data.correction_Frame},${data.process_Date}`;
                csvContent += row + "\n";
            });
        } else if (selectedReport === 'Date-Wise') {
            csvContent += "Employee ID,Employee Name,Actual Hours,Extra Hours,Fresh Frame,Correction Frame,Process Date\n";
            dateWiseData.forEach(data => {
                const row = `${data.employee_id},${data.employee_Name},${data.actual_Hours},${data.extra_Hours},${data.fresh_Frame},${data.correction_Frame},${data.process_Date}`;
                csvContent += row + "\n";
            });
        } else if (selectedReport === 'Title-Wise') {
            csvContent += "Employee ID,Employee Name,Title Code,Actual Hours,Extra Hours,Fresh Frame,Correction Frame,Process Date\n";
            titleWiseData.forEach(data => {
                const row = `${data.employee_id},${data.employee_Name},${data.title_Code},${data.actual_Hours},${data.extra_Hours},${data.fresh_Frame},${data.correction_Frame},${data.process_Date}`;
                csvContent += row + "\n";
            });
        }
    } else if (selectedTeam === 'Artist') {
        if (selectedReport === 'Date-Wise' && checked) {
            csvContent += "Employee ID,Employee Name,Title Code,Actual Hours,Extra Hours,Poly Creation Frame,Colorization Frame,Number of Reject QC,Process Date\n";
            artistdateWiseData.forEach(data => {
                const row = `${data.employee_id},${data.employee_Name},${data.title_Code},${data.actual_Hours},${data.extra_Hours},${data.poly_Creation_Frame},${data.colorization_Frame},${data.number_of_Reject_QC},${data.process_Date}`;
                csvContent += row + "\n";
            });
        } else if (selectedReport === 'Date-Wise') {
            csvContent += "Employee ID,Employee Name,Actual Hours,Extra Hours,Poly Creation Frame,Colorization Frame,Number of Reject QC,Process Date\n";
            artistdateWiseData.forEach(data => {
                const row = `${data.employee_id},${data.employee_Name},${data.actual_Hours},${data.extra_Hours},${data.poly_Creation_Frame},${data.colorization_Frame},${data.number_of_Reject_QC},${data.process_Date}`;
                csvContent += row + "\n";
            });
        } else if (selectedReport === 'Title-Wise') {
            csvContent += "Employee ID,Employee Name,Title Code,Reel Name,Shot Name,Actual Hours,Extra Hours,Poly Creation Frame,Colorization Frame,Number of Reject QC\n";
            artistTitleWiseData.forEach(data => {
                const row = `${data.employee_id},${data.employee_Name},${data.title_Code},${data.reel_Name},${data.shot_Name},${data.actual_Hours},${data.extra_Hours},${data.poly_Creation_Frame},${data.colorization_Frame},${data.number_of_Reject_QC}`;
                csvContent += row + "\n";
            });
        }
    }

    const date = new Date();
    const formattedDate = date.toISOString().slice(0, 10); 
    const filename = () => {
        if (selectedReport === 'Title-Wise') {
            return `${selectedTeam}_${selectedTitle}_${formattedDate}.csv`;
        } else if (selectedReport === 'Date-Wise') {
            return `${selectedTeam}_from-${startDate}_to-${endDate}.csv`;
        }
        return '';
    };
    
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", filename());
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); 
};

return (
    <div className="title_wise_cutlistreport">
    <Header>Performance Report</Header>
    <div  style={{display:"flex", alignItems: 'center', marginBottom:'20px'}}>
      <div style={{marginRight: "10px"}}>
        <label style={{fontWeight:"bold"}}>Team Type</label>
        <Dropdown
          clearable
          placeholder='Select an option'
          fluid
          selection
          options={teamoptions}
          value={selectedTeam}
          onChange={handleChangeTeam}
          style={{width:"200px"}}
        />
      </div>
      {selectedTeam !== '' ?
      <div style={{marginRight: "10px"}}>
        <label style={{fontWeight:"bold"}}>Report Type</label>
        <Dropdown
          clearable
          placeholder='Select an option'
          fluid
          selection
          options={reportoptions}
          value={selectedReport}
          onChange={handleChangeReport}
          style={{width:"200px"}}
        />
      </div> : null
      }
      {
        selectedTeam !== ''  && selectedReport === "Title-Wise" ? 
       <> <div style={{marginRight: "10px"}}>
          <label style={{fontWeight:"bold"}}>Title Code</label>
          <Dropdown
            clearable
            placeholder='Select an option'
            fluid
            selection
            options={assingTitleCode}
            value={selectedTitle}
            onChange={handleChangeTitle}
            style={{width:"250px"}}
          />
      </div>
      <div style={{marginRight: "10px", alignSelf:'end'}}>
        <Button onClick={handleViewReport} primary>View Report</Button>
        <Button onClick={handleDownloadReport} style={{width: '50px'}}><Icon name='download' /></Button>
      </div> 
      </>: null}
      {
        (selectedReport === "Date-Wise" && selectedTeam !=="") ? 
      <>
      <div className="date-wrapper" style={{marginRight: "10px"}}>
        <label style={{fontWeight:"bold"}}>From Date</label>
        <DatePicker
          placeholderText="From Date"
          value={
            startDate
              ? PivotStore.dateFormat(
                  moment(startDate).format('MM-DD-YYYY'),
                )
              : ''
          }
          className="date-picker-style-m0"
          showMonthDropdown
          showYearDropdown
          locale={'en'}
          dateFormatCalendar="MMMM"
          yearDropdownItemNumber={15}
          maxDate={moment().toDate()}
          scrollableYearDropdown
          onChange={(date: any) => setDate(date, 'start')}
          popperProps={{ strategy: 'fixed' }}
        />
      </div>
      <div className="date-wrapper" style={{marginRight: "10px"}}>
        <label style={{fontWeight:"bold"}}>To Date</label>
        <DatePicker
          placeholderText="To Date"
          value={
            endDate
              ? PivotStore.dateFormat(
                  moment(endDate).format('MM-DD-YYYY'),
                )
              : ''
          }
          className="date-picker-style-m0"
          showMonthDropdown
          showYearDropdown
          locale={'en'}
          dateFormatCalendar="MMMM"
          yearDropdownItemNumber={15}
          maxDate={moment().add(0, 'days').toDate()}
          scrollableYearDropdown
          onChange={(date: any) => setDate(date, 'end')}
          popperProps={{ strategy: 'fixed' }}
        />
      </div>
      <div style={{marginRight: "10px", alignSelf:'end', marginLeft:'10px'}}>
        <Checkbox label='Title Breakup' onClick={titleBreak} checked={checked} style={{ transform: 'scale(1.1)', marginRight: '10px',fontWeight: 'bold'}} />
      </div>
      <div style={{marginRight: "10px", alignSelf:'end'}}>
        <Button onClick={handleViewReport} primary>View Report</Button>
        <Button onClick={handleDownloadReport} style={{width: '50px'}}><Icon name='download' /></Button>
      </div>
    </>: null
      }
    </div>
    {loading ? (
        <Loader active inline='centered' />
     ) : (
     <div>
      {selectedTeam === 'QC' && selectedReport === 'Date-Wise' && (
        <div>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Employee ID</Table.HeaderCell>
                <Table.HeaderCell>Employee Name</Table.HeaderCell>
                { checked &&(<Table.HeaderCell>Title Code</Table.HeaderCell>)}
                <Table.HeaderCell>Actual Hours</Table.HeaderCell>
                <Table.HeaderCell>Extra Hours</Table.HeaderCell>
                <Table.HeaderCell>Fresh Frame</Table.HeaderCell>
                <Table.HeaderCell>Correction Frame</Table.HeaderCell>
                <Table.HeaderCell>Process Date</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {dateWiseData.length === 0 && (
                <Table.Row>
                  <Table.Cell colSpan={7} textAlign="center">
                    No data available for the selected date range.
                  </Table.Cell>
                </Table.Row>
              )}
              {dateWiseData.length > 0 && dateWiseData.map((data, index) => (
                <Table.Row key={index}>
                  <Table.Cell>{data.employee_id}</Table.Cell>
                  <Table.Cell>{data.employee_Name}</Table.Cell>
                  {checked && (<Table.Cell>{data.title_Code}</Table.Cell>)}
                  <Table.Cell>{data.actual_Hours}</Table.Cell>
                  <Table.Cell>{data.extra_Hours}</Table.Cell>
                  <Table.Cell>{data.fresh_Frame}</Table.Cell>
                  <Table.Cell>{data.correction_Frame}</Table.Cell>
                  <Table.Cell>{data.process_Date}</Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      )}
      {selectedTeam === 'QC' && selectedReport === 'Title-Wise' && titleWiseData.length > 0 && (
        <div>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Employee ID</Table.HeaderCell>
                <Table.HeaderCell>Employee Name</Table.HeaderCell>
                <Table.HeaderCell>Title Code</Table.HeaderCell>
                <Table.HeaderCell>Actual Hours</Table.HeaderCell>
                <Table.HeaderCell>Extra Hours</Table.HeaderCell>
                <Table.HeaderCell>Fresh Frame</Table.HeaderCell>
                <Table.HeaderCell>Correction Frame</Table.HeaderCell>
                <Table.HeaderCell>Process Date</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {titleWiseData.length === 0 && (
                <Table.Row>
                  <Table.Cell colSpan={7} textAlign="center">
                    No data available for the selected title range.
                  </Table.Cell>
                </Table.Row>
              )}
              {titleWiseData.length > 0 && titleWiseData.map((data, index) => (
                <Table.Row key={index}>
                  <Table.Cell>{data.employee_id}</Table.Cell>
                  <Table.Cell>{data.employee_Name}</Table.Cell>
                  <Table.Cell>{data.title_Code}</Table.Cell>
                  <Table.Cell>{data.actual_Hours}</Table.Cell>
                  <Table.Cell>{data.extra_Hours}</Table.Cell>
                  <Table.Cell>{data.fresh_Frame}</Table.Cell>
                  <Table.Cell>{data.correction_Frame}</Table.Cell>
                  <Table.Cell>{data.process_Date}</Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      )}
      {selectedTeam === 'Artist' && selectedReport === 'Date-Wise' &&(
        <div>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Employee ID</Table.HeaderCell>
                <Table.HeaderCell>Employee Name</Table.HeaderCell>
                { checked &&(<Table.HeaderCell>Title Code</Table.HeaderCell>)}
                <Table.HeaderCell>Actual Hours</Table.HeaderCell>
                <Table.HeaderCell>Extra Hours</Table.HeaderCell>
                <Table.HeaderCell>Poly Creation Frame</Table.HeaderCell>
                <Table.HeaderCell>Colorization Frame</Table.HeaderCell>
                <Table.HeaderCell>Number of Reject QC</Table.HeaderCell>
                <Table.HeaderCell>Process Date</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {artistdateWiseData.length === 0 && (
                <Table.Row>
                  <Table.Cell colSpan={7} textAlign="center">
                    No data available for the selected date range.
                  </Table.Cell>
                </Table.Row>
              )}
              {artistdateWiseData.length > 0 && artistdateWiseData.map((data, index) => (
                <Table.Row key={index}>
                  <Table.Cell>{data.employee_id}</Table.Cell>
                  <Table.Cell>{data.employee_Name}</Table.Cell>
                  {checked && (<Table.Cell>{data.title_Code}</Table.Cell>)}
                  <Table.Cell>{data.actual_Hours}</Table.Cell>
                  <Table.Cell>{data.extra_Hours}</Table.Cell>
                  <Table.Cell>{data.poly_Creation_Frame}</Table.Cell>
                  <Table.Cell>{data.colorization_Frame}</Table.Cell>
                  <Table.Cell>{data.number_of_Reject_QC}</Table.Cell>
                  <Table.Cell>{data.process_Date}</Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      )}
      {selectedTeam === 'Artist' && selectedReport === 'Title-Wise' && artistTitleWiseData.length > 0 && (
        <div>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Employee ID</Table.HeaderCell>
                <Table.HeaderCell>Employee Name</Table.HeaderCell>
                <Table.HeaderCell>Title Code</Table.HeaderCell>
                <Table.HeaderCell>Reel Name</Table.HeaderCell>
                <Table.HeaderCell>Shot Name</Table.HeaderCell>
                <Table.HeaderCell>Actual Hours</Table.HeaderCell>
                <Table.HeaderCell>Extra Hours</Table.HeaderCell>
                <Table.HeaderCell>Poly Creation Frame</Table.HeaderCell>
                <Table.HeaderCell>Colorization Frame</Table.HeaderCell>
                <Table.HeaderCell>Number of Reject QC</Table.HeaderCell>              
          </Table.Row>
            </Table.Header>
            <Table.Body>
              {artistTitleWiseData.length === 0 && (
                <Table.Row>
                  <Table.Cell colSpan={7} textAlign="center">
                    No data available for the selected title range.
                  </Table.Cell>
                </Table.Row>
              )}
              {artistTitleWiseData.length > 0 && artistTitleWiseData.map((data, index) => (
                <Table.Row key={index}>
                  <Table.Cell>{data.employee_id}</Table.Cell>
                  <Table.Cell>{data.employee_Name}</Table.Cell>
                  <Table.Cell>{data.title_Code}</Table.Cell>
                  <Table.Cell>{data.reel_Name}</Table.Cell>
                  <Table.Cell>{data.shot_Name}</Table.Cell>
                  <Table.Cell>{data.actual_Hours}</Table.Cell>
                  <Table.Cell>{data.extra_Hours}</Table.Cell>
                  <Table.Cell>{data.poly_Creation_Frame}</Table.Cell>
                  <Table.Cell>{data.colorization_Frame}</Table.Cell>
                  <Table.Cell>{data.number_of_Reject_QC}</Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      )}
      {selectedTeam === 'QC' && selectedReport === '' &&  (
          <div>
              <Table>
                  <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Employee ID</Table.HeaderCell>
                        <Table.HeaderCell>Employee Name</Table.HeaderCell>
                        <Table.HeaderCell>Actual Hours</Table.HeaderCell>
                        <Table.HeaderCell>Extra Hours</Table.HeaderCell>
                        <Table.HeaderCell>Fresh Frame</Table.HeaderCell>
                        <Table.HeaderCell>Correction Frame</Table.HeaderCell>
                        <Table.HeaderCell>Process Date</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                      <Table.Row>
                        <Table.Cell colSpan={7} textAlign="center">No data available.</Table.Cell>
                      </Table.Row>
                  </Table.Body>
              </Table>
          </div>      
      )}
      {selectedTeam === 'Artist' && selectedReport === '' &&  (
          <div>
              <Table>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Employee ID</Table.HeaderCell>
                      <Table.HeaderCell>Employee Name</Table.HeaderCell>
                      <Table.HeaderCell>Title Code</Table.HeaderCell>
                      <Table.HeaderCell>Reel Name</Table.HeaderCell>
                      <Table.HeaderCell>Shot Name</Table.HeaderCell>
                      <Table.HeaderCell>Actual Hours</Table.HeaderCell>
                      <Table.HeaderCell>Extra Hours</Table.HeaderCell>
                      <Table.HeaderCell>Poly Creation Frame</Table.HeaderCell>
                      <Table.HeaderCell>Colorization Frame</Table.HeaderCell>
                      <Table.HeaderCell>Number of Reject QC</Table.HeaderCell>              
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                      <Table.Row>
                        <Table.Cell colSpan={12} textAlign="center">No data available.</Table.Cell>
                      </Table.Row>
                  </Table.Body>
              </Table>
          </div>      
      )}
    </div>
     )}
    </div>
  );
}

export default OperatorPerformanceColorization;
